import { AxiosRequestConfig, AxiosResponse } from "axios";
import axios from "./axios";

async function axiosGet<T>(url: string, params?: AxiosRequestConfig["params"]): Promise<AxiosResponse<T>> {
  return axios.get(url, { params });
}

export default axiosGet;
